import { render, staticRenderFns } from "./ManageTasks.vue?vue&type=template&id=14be22b7&scoped=true&"
import script from "./ManageTasks.vue?vue&type=script&lang=ts&"
export * from "./ManageTasks.vue?vue&type=script&lang=ts&"
import style0 from "./ManageTasks.vue?vue&type=style&index=0&id=14be22b7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14be22b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VRow})
